var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSkin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 20C3.58333 20 0 16.6406 0 12.5C0 8.9375 5.425 2.25391 6.94167 0.457031C7.19167 0.164062 7.5625 0 7.9625 0H8.0375C8.4375 0 8.80833 0.164062 9.05833 0.457031C10.575 2.25391 16 8.9375 16 12.5C16 16.6406 12.4167 20 8 20ZM4 13.125C4 12.7812 3.7 12.5 3.33333 12.5C2.96667 12.5 2.66667 12.7812 2.66667 13.125C2.66667 15.543 4.75417 17.5 7.33333 17.5C7.7 17.5 8 17.2188 8 16.875C8 16.5312 7.7 16.25 7.33333 16.25C5.49167 16.25 4 14.8516 4 13.125Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSkin);
export default __webpack_public_path__ + "static/media/icon_skin.5e7922715be39c39a2ca218c470b70ba.svg";
export { ForwardRef as ReactComponent };